export default function Agb() {
  return (
    <div className="min-h-screen py-16 md:py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-10">
          Allgemeine Geschäftsbedingungen
        </h1>

        <div className="space-y-8 text-foreground-700">
          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Geltungsbereich
            </h2>
            <p>
              Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge, Lieferungen und Leistungen zwischen Klosek Metallbau GmbH und ihren Kunden.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Angebote und Vertragsschluss
            </h2>
            <p>
              Unsere Angebote sind freibleibend und unverbindlich. Ein Vertrag kommt erst zustande, wenn wir die Annahme eines Auftrags schriftlich oder durch Ausführung der Leistung bestätigen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Preise und Zahlungsbedingungen
            </h2>
            <p>
              Alle Preise verstehen sich zuzüglich der gesetzlichen Mehrwertsteuer. Zahlungen sind innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug fällig.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Lieferung und Montage
            </h2>
            <p>
              Liefertermine und -fristen werden nach bestem Wissen angegeben, sind jedoch unverbindlich, sofern nicht ausdrücklich schriftlich als verbindlich vereinbart. Wir sind zu Teillieferungen berechtigt.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Gewährleistung
            </h2>
            <p>
              Es gelten die gesetzlichen Gewährleistungsrechte. Die Gewährleistungsfrist beträgt 24 Monate ab Lieferung bzw. Abnahme.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Haftung
            </h2>
            <p>
              Die Haftung für leichte Fahrlässigkeit ist auf die Verletzung von wesentlichen Vertragspflichten und auf den vorhersehbaren, typischerweise eintretenden Schaden beschränkt. Diese Haftungsbeschränkung gilt nicht bei Verletzung von Leben, Körper oder Gesundheit sowie bei Arglist oder grober Fahrlässigkeit.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Erfüllungsort und Gerichtsstand
            </h2>
            <p>
              Erfüllungsort und Gerichtsstand ist Lüdenscheid, soweit der Kunde Vollkaufmann ist. Es gilt das Recht der Bundesrepublik Deutschland.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}